import type { Feature } from 'geojson'

const LABEL_KEYS = new Set([
  'name',
  'nom',
  'label',
  'titre',
  'libelle',
  'title',
  'code',
])

export function pickFeatureLabel(feature: Feature): string {
  const p = feature.properties
  if (!p || typeof p !== 'object') return 'Sans titre'

  const record = p as Record<string, unknown>
  for (const key of Object.keys(record)) {
    if (!LABEL_KEYS.has(key.toLowerCase())) continue
    const v = record[key]
    if (typeof v === 'string' && v.trim()) return v.trim()
  }

  const firstString = Object.values(record).find(
    v => typeof v === 'string' && String(v).trim(),
  )
  if (typeof firstString === 'string') return firstString.trim()

  const id = feature.id
  if (id !== undefined && id !== null) return `Objet ${String(id)}`

  return 'Sans titre'
}
